import { gql } from '@apollo/client';

const WORKER_PENDING_COMMANDS = gql`
  query workerPendingCommands($profileId: String) {
    workerPendingCommands(profileId: $profileId)
  }
`;
export default WORKER_PENDING_COMMANDS;
